import { AuctionOfferStatus } from '../../models/auction-constants';
import { TranslationService } from '../../../shared/services/translation.service';

export function getAuctionOfferStatusTr(translationService: TranslationService, status: AuctionOfferStatus) {
	switch (status) {
	case AuctionOfferStatus.AWARDED:
		return translationService.getTR('auction.offer.bid.awarded');
	case AuctionOfferStatus.PENDING:
		return translationService.getTR('auction.offer.bid.pending');
	case AuctionOfferStatus.REJECTED:
		return translationService.getTR('auction.offer.bid.rejected');
	default:
		return '';
	}
}
